/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as TermsRouteImport } from './routes/terms'
import { Route as SignupRouteImport } from './routes/signup'
import { Route as ResetPasswordRouteImport } from './routes/reset-password'
import { Route as PrivacyPolicyRouteImport } from './routes/privacy-policy'
import { Route as LogoutRouteImport } from './routes/logout'
import { Route as LoginRouteImport } from './routes/login'
import { Route as AuthenticatedRouteImport } from './routes/_authenticated'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AuthenticatedSentryTestRouteImport } from './routes/_authenticated/sentry-test'
import { Route as AuthenticatedInitialPreferencesRouteImport } from './routes/_authenticated/initial-preferences'
import { Route as AuthenticatedDashboardRouteImport } from './routes/_authenticated/dashboard'
import { Route as AuthenticatedAccountUpdatePasswordRouteImport } from './routes/_authenticated/account/update-password'
import { Route as AuthenticatedAccountSettingsRouteImport } from './routes/_authenticated/account/settings'
import { Route as AuthenticatedShareLocationsIndexRouteImport } from './routes/_authenticated/share/locations/index'
import { Route as AuthenticatedShareLocationsCodeRouteImport } from './routes/_authenticated/share/locations/$code'

const TermsRoute = TermsRouteImport.update({
  id: '/terms',
  path: '/terms',
  getParentRoute: () => rootRouteImport,
} as any)
const SignupRoute = SignupRouteImport.update({
  id: '/signup',
  path: '/signup',
  getParentRoute: () => rootRouteImport,
} as any)
const ResetPasswordRoute = ResetPasswordRouteImport.update({
  id: '/reset-password',
  path: '/reset-password',
  getParentRoute: () => rootRouteImport,
} as any)
const PrivacyPolicyRoute = PrivacyPolicyRouteImport.update({
  id: '/privacy-policy',
  path: '/privacy-policy',
  getParentRoute: () => rootRouteImport,
} as any)
const LogoutRoute = LogoutRouteImport.update({
  id: '/logout',
  path: '/logout',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedRoute = AuthenticatedRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedSentryTestRoute = AuthenticatedSentryTestRouteImport.update({
  id: '/sentry-test',
  path: '/sentry-test',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedInitialPreferencesRoute =
  AuthenticatedInitialPreferencesRouteImport.update({
    id: '/initial-preferences',
    path: '/initial-preferences',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedDashboardRoute = AuthenticatedDashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedAccountUpdatePasswordRoute =
  AuthenticatedAccountUpdatePasswordRouteImport.update({
    id: '/account/update-password',
    path: '/account/update-password',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedAccountSettingsRoute =
  AuthenticatedAccountSettingsRouteImport.update({
    id: '/account/settings',
    path: '/account/settings',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedShareLocationsIndexRoute =
  AuthenticatedShareLocationsIndexRouteImport.update({
    id: '/share/locations/',
    path: '/share/locations/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedShareLocationsCodeRoute =
  AuthenticatedShareLocationsCodeRouteImport.update({
    id: '/share/locations/$code',
    path: '/share/locations/$code',
    getParentRoute: () => AuthenticatedRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/logout': typeof LogoutRoute
  '/privacy-policy': typeof PrivacyPolicyRoute
  '/reset-password': typeof ResetPasswordRoute
  '/signup': typeof SignupRoute
  '/terms': typeof TermsRoute
  '/dashboard': typeof AuthenticatedDashboardRoute
  '/initial-preferences': typeof AuthenticatedInitialPreferencesRoute
  '/sentry-test': typeof AuthenticatedSentryTestRoute
  '/account/settings': typeof AuthenticatedAccountSettingsRoute
  '/account/update-password': typeof AuthenticatedAccountUpdatePasswordRoute
  '/share/locations/$code': typeof AuthenticatedShareLocationsCodeRoute
  '/share/locations/': typeof AuthenticatedShareLocationsIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/logout': typeof LogoutRoute
  '/privacy-policy': typeof PrivacyPolicyRoute
  '/reset-password': typeof ResetPasswordRoute
  '/signup': typeof SignupRoute
  '/terms': typeof TermsRoute
  '/dashboard': typeof AuthenticatedDashboardRoute
  '/initial-preferences': typeof AuthenticatedInitialPreferencesRoute
  '/sentry-test': typeof AuthenticatedSentryTestRoute
  '/account/settings': typeof AuthenticatedAccountSettingsRoute
  '/account/update-password': typeof AuthenticatedAccountUpdatePasswordRoute
  '/share/locations/$code': typeof AuthenticatedShareLocationsCodeRoute
  '/share/locations': typeof AuthenticatedShareLocationsIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_authenticated': typeof AuthenticatedRouteWithChildren
  '/login': typeof LoginRoute
  '/logout': typeof LogoutRoute
  '/privacy-policy': typeof PrivacyPolicyRoute
  '/reset-password': typeof ResetPasswordRoute
  '/signup': typeof SignupRoute
  '/terms': typeof TermsRoute
  '/_authenticated/dashboard': typeof AuthenticatedDashboardRoute
  '/_authenticated/initial-preferences': typeof AuthenticatedInitialPreferencesRoute
  '/_authenticated/sentry-test': typeof AuthenticatedSentryTestRoute
  '/_authenticated/account/settings': typeof AuthenticatedAccountSettingsRoute
  '/_authenticated/account/update-password': typeof AuthenticatedAccountUpdatePasswordRoute
  '/_authenticated/share/locations/$code': typeof AuthenticatedShareLocationsCodeRoute
  '/_authenticated/share/locations/': typeof AuthenticatedShareLocationsIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/login'
    | '/logout'
    | '/privacy-policy'
    | '/reset-password'
    | '/signup'
    | '/terms'
    | '/dashboard'
    | '/initial-preferences'
    | '/sentry-test'
    | '/account/settings'
    | '/account/update-password'
    | '/share/locations/$code'
    | '/share/locations/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/login'
    | '/logout'
    | '/privacy-policy'
    | '/reset-password'
    | '/signup'
    | '/terms'
    | '/dashboard'
    | '/initial-preferences'
    | '/sentry-test'
    | '/account/settings'
    | '/account/update-password'
    | '/share/locations/$code'
    | '/share/locations'
  id:
    | '__root__'
    | '/'
    | '/_authenticated'
    | '/login'
    | '/logout'
    | '/privacy-policy'
    | '/reset-password'
    | '/signup'
    | '/terms'
    | '/_authenticated/dashboard'
    | '/_authenticated/initial-preferences'
    | '/_authenticated/sentry-test'
    | '/_authenticated/account/settings'
    | '/_authenticated/account/update-password'
    | '/_authenticated/share/locations/$code'
    | '/_authenticated/share/locations/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AuthenticatedRoute: typeof AuthenticatedRouteWithChildren
  LoginRoute: typeof LoginRoute
  LogoutRoute: typeof LogoutRoute
  PrivacyPolicyRoute: typeof PrivacyPolicyRoute
  ResetPasswordRoute: typeof ResetPasswordRoute
  SignupRoute: typeof SignupRoute
  TermsRoute: typeof TermsRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/terms': {
      id: '/terms'
      path: '/terms'
      fullPath: '/terms'
      preLoaderRoute: typeof TermsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/signup': {
      id: '/signup'
      path: '/signup'
      fullPath: '/signup'
      preLoaderRoute: typeof SignupRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reset-password': {
      id: '/reset-password'
      path: '/reset-password'
      fullPath: '/reset-password'
      preLoaderRoute: typeof ResetPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/privacy-policy': {
      id: '/privacy-policy'
      path: '/privacy-policy'
      fullPath: '/privacy-policy'
      preLoaderRoute: typeof PrivacyPolicyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/logout': {
      id: '/logout'
      path: '/logout'
      fullPath: '/logout'
      preLoaderRoute: typeof LogoutRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated': {
      id: '/_authenticated'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/sentry-test': {
      id: '/_authenticated/sentry-test'
      path: '/sentry-test'
      fullPath: '/sentry-test'
      preLoaderRoute: typeof AuthenticatedSentryTestRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/initial-preferences': {
      id: '/_authenticated/initial-preferences'
      path: '/initial-preferences'
      fullPath: '/initial-preferences'
      preLoaderRoute: typeof AuthenticatedInitialPreferencesRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/dashboard': {
      id: '/_authenticated/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof AuthenticatedDashboardRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/account/update-password': {
      id: '/_authenticated/account/update-password'
      path: '/account/update-password'
      fullPath: '/account/update-password'
      preLoaderRoute: typeof AuthenticatedAccountUpdatePasswordRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/account/settings': {
      id: '/_authenticated/account/settings'
      path: '/account/settings'
      fullPath: '/account/settings'
      preLoaderRoute: typeof AuthenticatedAccountSettingsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/share/locations/': {
      id: '/_authenticated/share/locations/'
      path: '/share/locations'
      fullPath: '/share/locations/'
      preLoaderRoute: typeof AuthenticatedShareLocationsIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/share/locations/$code': {
      id: '/_authenticated/share/locations/$code'
      path: '/share/locations/$code'
      fullPath: '/share/locations/$code'
      preLoaderRoute: typeof AuthenticatedShareLocationsCodeRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
  }
}

interface AuthenticatedRouteChildren {
  AuthenticatedDashboardRoute: typeof AuthenticatedDashboardRoute
  AuthenticatedInitialPreferencesRoute: typeof AuthenticatedInitialPreferencesRoute
  AuthenticatedSentryTestRoute: typeof AuthenticatedSentryTestRoute
  AuthenticatedAccountSettingsRoute: typeof AuthenticatedAccountSettingsRoute
  AuthenticatedAccountUpdatePasswordRoute: typeof AuthenticatedAccountUpdatePasswordRoute
  AuthenticatedShareLocationsCodeRoute: typeof AuthenticatedShareLocationsCodeRoute
  AuthenticatedShareLocationsIndexRoute: typeof AuthenticatedShareLocationsIndexRoute
}

const AuthenticatedRouteChildren: AuthenticatedRouteChildren = {
  AuthenticatedDashboardRoute: AuthenticatedDashboardRoute,
  AuthenticatedInitialPreferencesRoute: AuthenticatedInitialPreferencesRoute,
  AuthenticatedSentryTestRoute: AuthenticatedSentryTestRoute,
  AuthenticatedAccountSettingsRoute: AuthenticatedAccountSettingsRoute,
  AuthenticatedAccountUpdatePasswordRoute:
    AuthenticatedAccountUpdatePasswordRoute,
  AuthenticatedShareLocationsCodeRoute: AuthenticatedShareLocationsCodeRoute,
  AuthenticatedShareLocationsIndexRoute: AuthenticatedShareLocationsIndexRoute,
}

const AuthenticatedRouteWithChildren = AuthenticatedRoute._addFileChildren(
  AuthenticatedRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AuthenticatedRoute: AuthenticatedRouteWithChildren,
  LoginRoute: LoginRoute,
  LogoutRoute: LogoutRoute,
  PrivacyPolicyRoute: PrivacyPolicyRoute,
  ResetPasswordRoute: ResetPasswordRoute,
  SignupRoute: SignupRoute,
  TermsRoute: TermsRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
